import React from "react";

import truncate from "lodash/truncate";
import { FormattedMessage } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { ReviewSummary } from "@/components/organisms/Review";
import { useClientEnvironment } from "src/app/environment/client";
import { IReview } from "~/types/api-types";
import { getProfileAvatarUrl } from "~/utils/profile.utils";

interface ReviewHighlightsProps {
  reviews: IReview[];
  trackReviewsAction: (e: React.MouseEvent) => void;
  listingId: string;
}

const ReviewHighlights: React.FC<ReviewHighlightsProps> = ({
  reviews,
  trackReviewsAction,
  listingId,
}) => {
  const { EXTERNAL_ADDRESS } = useClientEnvironment();
  return (
    <div className="tw-my-40">
      <div className="xs:tw-hidden sm:tw-flex tw-flex-col tw-gap-16">
        {reviews.map((review, i) => {
          const isAttendeeReview = review.review_type === "attendee";
          const reviewerName = isAttendeeReview
            ? review.reviewer_name
            : review.guest?.name;
          const reviewAvatarId = isAttendeeReview
            ? review.reviewer_avatar_id
            : review.guest?.avatar_id;
          const parsedReview =
            review.review_text.match(/([^.!?]+[.!?]+)|([^.!?]+$)/g) || "";
          const reviewSnippet = truncate(parsedReview[0], {
            length:
              100 - (reviewerName.first.length + reviewerName.last.length),
            separator: " ",
          });
          const avatarId = getProfileAvatarUrl(reviewAvatarId);

          return (
            <ReviewSummary
              key={i}
              avatar={avatarId}
              reviewText={reviewSnippet}
              firstName={reviewerName.first || "Unknown"}
              lastName={reviewerName.last || "Unknown"}
              productSchemaId={`${EXTERNAL_ADDRESS}/pages/listings/${listingId}`}
            />
          );
        })}
        <Button
          variant="underline-m"
          onClick={(e) =>
            trackReviewsAction(e as React.MouseEvent<HTMLButtonElement>)
          }
          className="tw-self-start"
        >
          <FormattedMessage
            id="listing.listing_main.read_reviews_link"
            defaultMessage="Read all reviews"
          />
        </Button>
      </div>
    </div>
  );
};

export default ReviewHighlights;
